import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCollectionDraftsByWallet } from '../../../hooks/DraftHook';
import NFTCardPlaceholder from '../NFTCardPlaceholder';
import Pagination from '../../Pagination';
import { getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';

function CollectionDraft() {
  const [collectionList, setCollectionList] = useState([]);
  const [displayedCollections, setDisplayedCollections] = useState([]); // Collections for the current page
  const [checkLoaderOwn, setCheckLoaderOwn] = useState(false);
  const walletAddress = localStorage.getItem("WalletAddress");
  const [limit] = useState(6); // Number of items per page
  const [hasMore, setHasMore] = useState(true); // Flag for skeleton loader
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    AllCollection();
  }, [currentPage]);

  // useEffect(() => {
  //   updateDisplayedCollections();
  // }, [collectionList, currentPage]);

  //get Collection Details
  const AllCollection = async () => {
    try {
      const Query = { page: currentPage + 1, limit, ownerAddress: walletAddress, isDraft: true }
      getCollectionListbyWalletAddress(Query).then((data) => {

        if (data.success) {
          const collections = data.data;
          console.log("collections", data, collections);
          setPageCount(data.totalPages)
          setCollectionList(collections);
          setHasMore(data.total > 0);

        } else {
          setCheckLoaderOwn(false);
        }
      })
    } catch (error) {
      console.error("Error fetching collections:", error);
    }
  };

  const updateDisplayedCollections = () => {
    const startIndex = currentPage * limit;
    const endIndex = startIndex + limit;
    setDisplayedCollections(collectionList.slice(startIndex, endIndex));
  };

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected);
  };

  console.log(";dvlmfb", hasMore);

  return (
    <div>
      <div className="row mb-30_reset">
        {collectionList.length !== 0 ? (
          collectionList.map((val, i) => (
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 card-hover-effect" key={i}>
              <div className="card__item four">
                <Link to={`/draftCollection/${val._id}`}>
                  <div className="card_body space-y-10">
                    <div className="creators space-x-10"></div>
                    <div className="card_head">
                      <div>
                        <img src={val.logo} alt="nftimage" />
                      </div>
                    </div>
                    <div className="card_footer d-block space-y-10">
                      <div className="card_footer justify-content-between">
                        <h6 className="card_title">
                          <div className="color_black">{val.name}</div>
                          <div className="color_black">
                            Symbol: <span style={{ textTransform: "uppercase" }}>{val.symbol}</span>
                          </div>
                        </h6>
                        <button className="btn btn-sm btn-primary">View</button>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))
        ) : hasMore ? (
          // Display skeleton loaders
          [...Array(limit)].map((_, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <NFTCardPlaceholder />
            </div>
          ))
        ) : (
          <h3>No Collections Available</h3>
        )}

        {pageCount > 1 && (
          <Pagination
            pageCount={pageCount}
            onPageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
}

export default CollectionDraft;
